const ENC: Record<string, string> = {
    '+': '-',
    '/': '_',
    '=': '.'
}

export function urlSafeBase64Encode(v: string): string {
    return btoa(v).replace(/[+/=]/g, (m) => {
        return ENC[m];
    });
}

export function urlSafeBase64AsJson(o: any): string {
    return urlSafeBase64Encode(JSON.stringify(o));
}